import React from "react";

function RefundPolicy() {
  return (
    <div
      style={{
        background: "#fff",
        minHeight: "100vh",
        color: "#0f172a",
        paddingBottom: 80,
      }}
    >
      <div
        style={{
          maxWidth: 1050,
          margin: "0 auto",
          padding: "80px 20px 0",
        }}
      >
        <section
          style={{
            borderRadius: 32,
            padding: "60px 40px",
            background: "#fff",
            boxShadow: "0 35px 120px rgba(15,23,42,0.12)",
            border: "1px solid rgba(226,232,240,0.9)",
          }}
        >
          <p
            style={{
              textTransform: "uppercase",
              letterSpacing: 4,
              fontWeight: 600,
              color: "#4f46e5",
              fontSize: 14,
              marginBottom: 8,
            }}
          >
            Refund Policy
          </p>
          <h1
            style={{
              fontSize: 44,
              fontWeight: 900,
              marginTop: 10,
            }}
          >
            EventNova Refund Policy
          </h1>
          <p
            style={{
              marginTop: 16,
              fontSize: 18,
              lineHeight: 1.8,
              color: "#1e293b",
            }}
          >
            EventNova is a vendor discovery platform that helps users find, explore, and connect with event service providers. We do not process bookings or payments between users and vendors. As a result, our refund policy applies only to services paid directly to EventNova specifically vendor subscription plans and advertising placements.
          </p>
        </section>

        <section style={{ marginTop: 50 }}>
          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2 style={{ fontSize: 26, marginBottom: 20, fontWeight: 800, color: "#0f172a" }}>
              1. Vendor Subscription Plans
            </h2>

            <h3
              style={{
                fontSize: 20,
                marginTop: 24,
                marginBottom: 12,
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              1.1 Non-Refundable Payments
            </h3>
            <p style={{ marginBottom: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              All subscription payments made by vendors to EventNova are non-refundable. This includes:
            </p>
            <ul style={{ paddingLeft: 20, lineHeight: 1.6, fontSize: 16, color: "#1e293b" }}>
              <li style={{ marginBottom: 8 }}>Monthly, quarterly, or yearly subscription plans</li>
              <li style={{ marginBottom: 8 }}>Vendor profile upgrades</li>
              <li style={{ marginBottom: 8 }}>Premium visibility packages</li>
              <li style={{ marginBottom: 8 }}>Any recurring subscription charges</li>
            </ul>
            <p style={{ marginTop: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              Once a vendor subscribes, their profile and features are activated immediately, and the platform services become accessible—therefore payments cannot be reversed.
            </p>

            <h3
              style={{
                fontSize: 20,
                marginTop: 28,
                marginBottom: 12,
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              1.2 Exceptions (Refunds Only in Special Cases)
            </h3>
            <p style={{ marginBottom: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              EventNova may issue a refund or credit only in the following circumstances:
            </p>
            <ul style={{ paddingLeft: 20, lineHeight: 1.6, fontSize: 16, color: "#1e293b" }}>
              <li style={{ marginBottom: 8 }}>A vendor was charged twice for the same subscription (duplicate payment)</li>
              <li style={{ marginBottom: 8 }}>A technical error on EventNova's system caused incorrect billing</li>
              <li style={{ marginBottom: 8 }}>The vendor could not access their account or profile due to a verified platform malfunction</li>
            </ul>
            <p style={{ marginTop: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              Requests must be submitted within 7 days of the transaction.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2 style={{ fontSize: 26, marginBottom: 20, fontWeight: 800, color: "#0f172a" }}>
              2. Advertising & Promotional Services
            </h2>

            <h3
              style={{
                fontSize: 20,
                marginTop: 24,
                marginBottom: 12,
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              2.1 Non-Refundable Ads
            </h3>
            <p style={{ marginBottom: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              Payments for advertising placements are non-refundable, including:
            </p>
            <ul style={{ paddingLeft: 20, lineHeight: 1.6, fontSize: 16, color: "#1e293b" }}>
              <li style={{ marginBottom: 8 }}>Banner ads</li>
              <li style={{ marginBottom: 8 }}>Sponsored vendor spots</li>
              <li style={{ marginBottom: 8 }}>Featured listings</li>
              <li style={{ marginBottom: 8 }}>EventNova homepage or category page promotions</li>
            </ul>
            <p style={{ marginTop: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              Advertising campaigns begin immediately upon activation, making them non-reversible.
            </p>

            <h3
              style={{
                fontSize: 20,
                marginTop: 28,
                marginBottom: 12,
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              2.2 Exceptional Cases
            </h3>
            <p style={{ marginBottom: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              A refund or partial credit may be offered only if:
            </p>
            <ul style={{ paddingLeft: 20, lineHeight: 1.6, fontSize: 16, color: "#1e293b" }}>
              <li style={{ marginBottom: 8 }}>The advertisement was not displayed due to a confirmed system error</li>
              <li style={{ marginBottom: 8 }}>A wrong campaign was activated due to a platform malfunction</li>
            </ul>
            <p style={{ marginTop: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              Refunds are reviewed case-by-case.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2 style={{ fontSize: 26, marginBottom: 20, fontWeight: 800, color: "#0f172a" }}>
              3. No Responsibility for Vendor–Customer Transactions
            </h2>
            <p style={{ marginBottom: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              EventNova does not:
            </p>
            <ul style={{ paddingLeft: 20, lineHeight: 1.6, fontSize: 16, color: "#1e293b" }}>
              <li style={{ marginBottom: 8 }}>Handle bookings</li>
              <li style={{ marginBottom: 8 }}>Collect payments on behalf of vendors</li>
              <li style={{ marginBottom: 8 }}>Guarantee vendor pricing, service quality, or delivery</li>
              <li style={{ marginBottom: 8 }}>Mediate financial disputes between customers and vendors</li>
            </ul>
            <p style={{ marginTop: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              Any issues relating to services rendered by vendors must be settled directly between the vendor and the customer.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2 style={{ fontSize: 26, marginBottom: 20, fontWeight: 800, color: "#0f172a" }}>
              4. Refund Processing Time
            </h2>
            <p style={{ marginBottom: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              If a refund is approved, processing will follow the original payment method:
            </p>
            <ul style={{ paddingLeft: 20, lineHeight: 1.6, fontSize: 16, color: "#1e293b" }}>
              <li style={{ marginBottom: 8 }}>Card payments: 5–10 business days</li>
              <li style={{ marginBottom: 8 }}>Bank transfers: 3–5 business days</li>
              <li style={{ marginBottom: 8 }}>Wallet/credit refunds (if used): Same day</li>
            </ul>
            <p style={{ marginTop: 12, lineHeight: 1.7, fontSize: 16, color: "#1e293b" }}>
              Delays caused by banks or payment gateways are outside our control.
            </p>
          </div>

          <section
            style={{
              marginTop: 48,
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.85)",
              color: "#0f172a",
              boxShadow: "0 15px 40px rgba(15,23,42,0.08)",
            }}
          >
            <h2 style={{ fontSize: 26, marginBottom: 20, fontWeight: 800, color: "#0f172a" }}>
              5. Contact Support
            </h2>
            <p style={{ lineHeight: 1.8, marginBottom: 0, fontSize: 16, color: "#1e293b" }}>
              For billing or refund queries, contact:{" "}
              <a
                href="mailto:info@eventnova.com.ng"
                style={{ color: "#4f46e5", textDecoration: "underline" }}
              >
                info@eventnova.com.ng
              </a>
            </p>
            <p style={{ lineHeight: 1.8, marginTop: 12, fontSize: 16, color: "#1e293b" }}>
              Provide your business name, invoice ID, payment date, and a brief description of the issue.
            </p>
          </section>
        </section>
      </div>
    </div>
  );
}

export default RefundPolicy;
